export const POWER_VOLTAGE_SYSTEM = {
  TRANSFORMER_TCU_RED_THRESHOLD: 75,
  TRANSFORMER_TCU_GRAY_THRESHOLD: 65,
  BATTERY_VOLTAGE_RED_THRESHOLD: 90,
  BATTERY_VOLTAGE_GRAY_THRESHOLD: 100,
  BATTERY_TEMP_RED_THRESHOLD: 40,
  BATTERY_TEMP_GRAY_THRESHOLD: 30,
  CUTTER_OPEN_FAILED: 2,
  CUTTER_COMMISSION_FAILED: 6,
  CUTTER_CANNOT_BE_COMMISSIONED: 7,
  PANTOGRAPH_LOWER_FAILED: 1,
  SKA1_PANTOGRAPH_RAISE_FAILED: 4,
  SKA2_PANTOGRAPH_RAISE_FAILED: 5,
  STATUS: {
    PANTOGRAPH_DOWN: 0,
    PANTOGRAPH_UP: 1,
    BATTERY_CHAR_ERROR: 0
  }
} as const;
